// utils/movimento/impostos.js

export const toNumber = (value) => {
    const n = Number(value || 0);
    return Number.isFinite(n) ? n : 0;
};

export const obterValorTotalComImpostos = (item = {}) => {
    return Number((toNumber(item.valorTotal) + toNumber(item.ipi) + toNumber(item.icmsST) + toNumber(item.fecoepST)).toFixed(2));
};

export const obterValorTotalSemImpostos = (item = {}) => {
    return toNumber(item.valorTotal);
};

export const obterValorImpostos = (item = {}) => {
    return Number((toNumber(item.ipi) + toNumber(item.icmsST) + toNumber(item.fecoepST)).toFixed(2));
};
